var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"si si-search",attrs:{"title":_vm.$t('tooltip_icon_search')},on:{"click":_vm.toggleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }